export const convertToMinutes = seconds => Number((seconds / 60).toFixed(3));